// export const API_URL= "https://dev-mms-digi-dep-api.azurewebsites.net/api"
//export const API_URL= "https://qa-mms-digi-dep-api.azurewebsites.net/api"

// const isLocalhost = () => {
//   const { hostname } = window.location
//   return hostname === 'localhost'
// }

// const localHostapi = 'http://localhost:8000/api'

// export const API_URL = isLocalhost()
//   ? localHostapi
//   : process.env.REACT_APP_DEP_API_URL

//Actual backend url
export const API_URL = process.env.REACT_APP_DEP_API_URL

// export const CONSULTANT_API_URL = isLocalhost()
//   ? localHostapi
//   : process.env.REACT_APP_DEP_CONSULTANT_API_URL

export const CONSULTANT_API_URL = process.env.REACT_APP_DEP_CONSULTANT_API_URL
